import { render } from "./TrainerSessionManagement.vue?vue&type=template&id=5570fa41&scoped=true"
import script from "./TrainerSessionManagement.vue?vue&type=script&lang=js"
export * from "./TrainerSessionManagement.vue?vue&type=script&lang=js"

import "./TrainerSessionManagement.vue?vue&type=style&index=0&id=5570fa41&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5570fa41"]])

export default __exports__